module.exports = __webpack_public_path__ + "img/81.77f143a3.jpg";